import { render } from "./UploadLocalVolume.vue?vue&type=template&id=5852eb01&scoped=true"
import script from "./UploadLocalVolume.vue?vue&type=script&lang=js"
export * from "./UploadLocalVolume.vue?vue&type=script&lang=js"

import "./UploadLocalVolume.vue?vue&type=style&index=0&id=5852eb01&scoped=true&lang=less"

import exportComponent from "/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5852eb01"]])

export default __exports__